var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"wrapper"},[_c('left-navbar'),_c('div',{staticClass:"content",attrs:{"id":"content"}},[_c('header-navbar'),_c('breadcrumb'),_c('div',{staticClass:"main-content"},[_c('router-view')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }